import React from 'react'

const StarEllipse = ({...r}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...r}>
      <circle cx="2" cy="12" r="1" fill="#126FFF"></circle>
      <circle cx="17" cy="12" r="1" fill="#126FFF"></circle>
      <circle cx="12" cy="2" r="1" fill="#126FFF"></circle>
      <circle cx="12" cy="7" r="1" fill="#126FFF"></circle>
      <circle cx="7" cy="12" r="1" fill="#126FFF"></circle>
      <circle cx="22" cy="12" r="1" fill="#126FFF"></circle>
      <circle cx="12" cy="12" r="1" fill="#126FFF"></circle>
      <circle cx="12" cy="17" r="1" fill="#126FFF"></circle>
      <circle
        cx="8.465"
        cy="8.464"
        r="1"
        fill="#126FFF"
        transform="rotate(-45 8.465 8.464)"
      ></circle>
      <circle
        cx="15.536"
        cy="15.536"
        r="1"
        fill="#126FFF"
        transform="rotate(-45 15.536 15.536)"
      ></circle>
      <circle
        cx="15.536"
        cy="8.465"
        r="1"
        fill="#126FFF"
        transform="rotate(45 15.536 8.465)"
      ></circle>
      <circle
        cx="8.464"
        cy="15.535"
        r="1"
        fill="#126FFF"
        transform="rotate(45 8.464 15.535)"
      ></circle>
      <circle cx="12" cy="22" r="1" fill="#126FFF"></circle>
    </svg>
  )
}

export default StarEllipse